import React from "react";
import { MenuItem, Paper, TextField } from "@material-ui/core";
import TitleBox from "../components/common/TitleBox";
import { insiders, prm } from "../mocks";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import ReportListItem from "../components/Main/ReportSection/ReportListItem";
import { useHistory } from "react-router-dom";
import paths from "../routes/paths";

export default function OperatorAssignment(props) {
  const classes = styles();
  const history = useHistory();

  const handleItemPress = passenger => {
    console.log("Premuto ", passenger);
  };

  return (
    <Paper elevation={0} square>
      <TitleBox title={"Operatore"} />
      <form className={classes.formContainer}>
        <TextField
          id="operator-name"
          select
          label={"Nome Operatore"}
          className={classes.fullInput}
          //onChange={handleChange}
        >
          {insiders.map(insider => (
            <MenuItem key={insider} value={insider}>
              {insider}
            </MenuItem>
          ))}
        </TextField>
      </form>
      <TitleBox title={"Lista PRM"} />
      {
        prm.map((item, index) => (
        <ReportListItem
          passenger={item}
          greyBackground={index % 2 !== 0}
          onPress={handleItemPress.bind(this)}
        />
      ))}
    </Paper>
  );
}

const styles = makeStyles(theme =>
  createStyles({
    fullInput: {
      width: "100%"
    },
    formContainer: {
      padding: 16
    }
  })
);
